import React, { useEffect, useState } from "react";
import { Loading } from "notiflix";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  // DeleteCoupon,
  // UpdateCoupon,
  // createCoupon,
  // getAllCoupons,
  getTevoPromotionCodes,
} from "../../redux/actions/CouponCode";
// import { formatCouponDiscount, encodeCouponDiscount, decodeCouponDiscount } from "../../utils/couponHelpers";
// import Spinner from "../../Components/Loading/Spinner";
import {
  // X,
  // Plus,
  RefreshCw,
  // Pencil,
  // Trash2,
  // Tag,
  Ticket,
  Copy,
  Check,
} from "lucide-react";

// const inputClass =
//   "w-full px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-[14px] placeholder:text-white/25 focus:outline-none focus:ring-2 focus:ring-[#E52324]/30 focus:border-[#E52324]/40 transition-all";

// const labelClass =
//   "block text-[10px] text-white/40 uppercase tracking-wider mb-1.5";

// const formatDate = (date) => {
//   if (!date) return "—";
//   return new Date(date).toLocaleString("en-US", {
//     month: "short",
//     day: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// };

const CouponCode = () => {
  // --- InstaPass local coupon admin (commented out — use TEVO Settings instead)
  // const [createevent, setcreateevent] = useState(false);
  // const [promoCode, setpromoCode] = useState("");
  // const [discount, setdiscount] = useState("");
  // const [isPercentage, setIsPercentage] = useState(false);
  // const [isUpdate, setIsUpdate] = useState(false);
  // const [id, setId] = useState(null);
  const [copiedCode, setCopiedCode] = useState(null);
  const [tevoCodes, setTevoCodes] = useState([]);
  const [tevoLoading, setTevoLoading] = useState(false);
  const dispatch = useDispatch();
  const CouponLoading = useSelector((state) => state.couponcode.CouponLoading);
  // const AllCouponCode = useSelector((state) => state.couponcode.AllCouponCode);
  // const couponList = Array.isArray(AllCouponCode) ? AllCouponCode : [];

  const copyPromoCode = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopiedCode(code);
      toast.success("Promo code copied", { duration: 2000 });
      setTimeout(() => setCopiedCode(null), 2000);
    } catch {
      toast.error("Could not copy promo code");
    }
  };

  // const resetForm = () => { ... };
  // const openCreate = () => { ... };
  // const handleSubmit = async () => { ... };
  // const openEdit = (item) => { ... };

  const loadTevoCodes = async () => {
    setTevoLoading(true);
    const result = await dispatch(getTevoPromotionCodes());
    setTevoCodes(Array.isArray(result?.promotion_codes) ? result.promotion_codes : []);
    setTevoLoading(false);
  };

  useEffect(() => {
    // dispatch(getAllCoupons());
    loadTevoCodes();
  }, [dispatch]);

  useEffect(() => {
    if (CouponLoading || tevoLoading) {
      Loading.standard("Loading Please Wait", { svgColor: "#E52324" });
    } else {
      Loading.remove();
    }
  }, [CouponLoading, tevoLoading]);

  return (
    <div
      className="p-6 sm:p-8"
      style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#E52324]/15 border border-[#E52324]/20 flex items-center justify-center shrink-0">
            <Ticket className="w-5 h-5 text-[#E52324]" strokeWidth={2} />
          </div>
          <div>
            <h1 className="text-[22px] text-white" style={{ fontWeight: 800 }}>
              Promo Codes
            </h1>
            <p className="text-white/30 text-[12px] mt-1">
              Ticket Evolution promotions ({tevoCodes.length} synced).
            </p>
          </div>
        </div>
        {/* <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            onClick={loadTevoCodes}
            disabled={tevoLoading}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/[0.08] text-white/50 hover:text-white hover:bg-white/[0.03] text-[12px] transition-all"
            style={{ fontWeight: 600 }}
          >
            <RefreshCw className={`w-4 h-4 ${tevoLoading ? "animate-spin" : ""}`} />
            Reload
          </button>
        </div> */}
      </div>

      <div>
        <div className="flex justify-between items-center mb-4">
          <div>
            <h3 className="text-[17px] text-white" style={{ fontWeight: 700 }}>
              Ticket Evolution Promotions ({tevoCodes.length})
            </h3>
            <p className="text-[12px] text-white/35 mt-1">
              Synced from{" "}
              <a
                href="https://settings.ticketevolution.com/brokerage/promotion_codes"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E52324] hover:underline"
              >
                TEVO Settings
              </a>
              . Create or edit promotion codes there — they apply automatically at checkout.
            </p>
          </div>
          <button
            type="button"
            onClick={loadTevoCodes}
            disabled={tevoLoading}
            className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-white/[0.08] text-white/50 hover:text-white text-[12px]"
            style={{ fontWeight: 600 }}
          >
            <RefreshCw className={`w-4 h-4 ${tevoLoading ? "animate-spin" : ""}`} />
            Sync TEVO
          </button>
        </div>

        {tevoLoading && tevoCodes.length === 0 ? (
          <div className="bg-[#0B1120] border border-[#1a1f30] rounded-2xl py-10 text-center text-white/40 text-[13px]">
            Loading Ticket Evolution promotion codes…
          </div>
        ) : tevoCodes.length === 0 ? (
          <div className="bg-[#0B1120] border border-[#1a1f30] rounded-2xl py-10 px-4 text-center">
            <p className="text-[13px] text-white/40">
              No TEVO promotion codes returned. Add them in Ticket Evolution Settings or check API credentials.
            </p>
          </div>
        ) : (
          <div className="bg-[#0B1120] border border-[#1a1f30] rounded-2xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[640px]">
                <thead>
                  <tr className="border-b border-[#1a2744] bg-[#0F172A]/50">
                    <th className="px-5 py-3.5 text-left text-[10px] uppercase tracking-wider text-white/40 font-semibold">
                      Code
                    </th>
                    <th className="px-5 py-3.5 text-left text-[10px] uppercase tracking-wider text-white/40 font-semibold">
                      Name
                    </th>
                    <th className="px-5 py-3.5 text-left text-[10px] uppercase tracking-wider text-white/40 font-semibold">
                      Discount
                    </th>
                    <th className="px-5 py-3.5 text-left text-[10px] uppercase tracking-wider text-white/40 font-semibold">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#1a2744]">
                  {tevoCodes.map((item) => (
                    <tr key={item.id || item.code} className="hover:bg-white/[0.02]">
                      <td className="px-5 py-4">
                        <button
                          type="button"
                          onClick={() => copyPromoCode(item.code)}
                          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-blue-500/10 border border-blue-500/20 text-blue-300 text-[12px]"
                          style={{ fontWeight: 700 }}
                        >
                          {item.code}
                          {copiedCode === item.code ? (
                            <Check className="w-3.5 h-3.5 text-emerald-400" />
                          ) : (
                            <Copy className="w-3.5 h-3.5 opacity-60" />
                          )}
                        </button>
                      </td>
                      <td className="px-5 py-4 text-[13px] text-white/60">{item.name || "—"}</td>
                      <td className="px-5 py-4 text-[14px] text-emerald-400" style={{ fontWeight: 700 }}>
                        {item.percentage ? `${item.value}%` : `$${item.value}`}
                      </td>
                      <td className="px-5 py-4">
                        <span
                          className={`text-[11px] px-2 py-1 rounded-full ${
                            item.active
                              ? "bg-emerald-500/15 text-emerald-400"
                              : "bg-white/10 text-white/40"
                          }`}
                        >
                          {item.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CouponCode;
